import * as React from 'react';
import classnames from 'classnames';
import '@grandvisionhq/common';
import { StickyMobileCtaAndPrice } from '../../../../StickyCta/StickyMobileCtaAndPrice.js';
import { SolutionsCTA } from '../SolutionsCTA/SolutionsCTA.js';
import { SolutionsUnitLabel } from './SolutionsUnitLabel.js';

const SolutionsStickyCTA = ({ className  })=>/*#__PURE__*/ React.createElement(StickyMobileCtaAndPrice, {
        className: classnames('solutions-sticky-cta', className),
        cta: /*#__PURE__*/ React.createElement(SolutionsCTA, null),
        priceSubtitle: /*#__PURE__*/ React.createElement(SolutionsUnitLabel, {
            className: "solutions-sticky-cta__subtitle"
        })
    })
;

export { SolutionsStickyCTA };
//# sourceMappingURL=SolutionsStickyCTA.js.map
